<template>
    <div class="pc-index">
        <TheHeader class="pc-header" />
        <div class="nav-page clearfix">
            <div class="nav-page-title">喜得</div>
            <div class="nav-page-list clearfix">
                <router-link 
                    class="nav-page-list-item" 
                    to="/example"
                >
                    案例
                </router-link>
                <router-link 
                    class="nav-page-list-item" 
                    to="/product"
                >
                    产品
                </router-link>
                <router-link 
                    class="nav-page-list-item" 
                    to="/method"
                >
                    方法
                </router-link>
                <router-link 
                    class="nav-page-list-item" 
                    to="/industry-experience"
                >
                    行业经验
                </router-link>
            </div>
        </div>

        <IndexExample :exampleList="exampleList" />

        <div class="list-aboutus">
            <router-link 
                    class="list-aboutus_btn" 
                    to="/aboutus">
                关于我们
            </router-link>
            <img class="list-aboutus_bg" :src="'./images/index/list-aboutus.png'">
            <p class="list-aboutus_text">我们作为体验设计/服务设计提供商，<br> 帮助企业全面提升与客户的数字化互动体验。 </p>
            <p class="list-aboutus_text">喜得认为，要真正赢得客户的感动与满意，在应用更多技术的同时，也需要更多用心的设计，两者平衡才体现真正的智慧，从而在市场中脱颖而出。</p>
        </div>

        <div class="service">
            <router-link class="service_btn" to="/service">我们的服务</router-link>
            <img class="service_bg" :src="'./images/index/service-bg.png'">
            <div class="service-list">
                <router-link 
                    class="service-list-item" 
                    to="/service"
                >设计与实施</router-link>
                <router-link 
                    class="service-list-item" 
                    to="/service"
                >咨询与设计</router-link>
                <router-link
                    class="service-list-item" 
                    to="/service"
                >设计与开发</router-link>
            </div>
        </div>

        <div class="contact">
            <img class="contact_bg" :src="'./images/index/contact_bg.jpg'">
            <div class="contact-content">
                <img class="contact-code" src="@/assets/images/contact_ma.png">
                <div class="contact-text1">
                    心动而喜 满意而得<br>
                    我们期待与您的合作！
                </div>
                <BaseAddress class="index-address"/>
            </div>
        </div>
        <TheFooter class="pc-the-footer-index"/>
    </div>
</template>

<script>
    import TheHeader from '@/components/module/TheHeader'
    import TheFooter from '@/components/module/TheFooter'
    import '@/assets/less/module/module-the-header_pc-header.less'
    import '@/assets/less/module/module-the-footer-index_pc-the-footer-index.less'
    
    import IndexExample from '@/components/module/IndexExample'
    import BaseAddress from '@/components/module/BaseAddress'

    import '@/assets/less/module/module-base-address_index-address.less'
    import '@/assets/less/module/module-pc-index_pc-index.less'


    export default {

        name: 'PCIndex',
        props: {
            exampleList: Array
        },
        data: function(){
            return {}
        },       
        components: {
            TheHeader,
            TheFooter,
            IndexExample,
            BaseAddress,
        },
        mounted() { }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
 
.nav-page-list-item {
    font-family: "SF Pro SC","SF Pro Text","SF Pro Icons","PingFang SC","Helvetica Neue","Helvetica","Arial",sans-serif;
}

</style>